import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IViewTestsStrings extends LocalizedStringsMethods {
    lsSettingsTxt: string;
    lsLogOutTxt: string;
    lsBackToProfileTxt: string;
    lsTestHistory: string;
    lsReturnToActivityTxt: string;
    lsDownloadTestTxt: string;
    lsShareTestTxt: string;
    lsShareReturnToActivityTxt: string;
    lsDownloadTxt: string;
    lsExportProfileTxt: string;
    lsTestExportSuccessTxt: string;
    lsTestSharedSuccessTxt: string;
    lsTestSharedFailedTxt: string;
    lsReturnToActivTestHisTxt: string;
    lsProfilesTxt: string;
    lsHomeTxt: string;
    lsTestsTxt: string;    
    lsOkTxt: string;    
    lsPrintTxt: string;
    lsYesTxt: string;
    lsNoTxt: string;
    lsShareTxt: string;
    lsDisclaimerTxt: string;
    lsDisclaimerInfoTxt: string;
    lsSeverlyImpairedTxt: string;
    lsModeratelyImpairedTxt: string;
    lsMildlyImpairedTxt: string;
    lsBorderlineTxt: string;
    lsLowAverageTxt: string;
    lsAverageTxt: string;
    lsHighAverageTxt: string;
    lsSuperiorTxt: string;
    lsVerySuperiorTxt: string;
    lsVSPTxt: string;
    lsSUPTxt: string;
    lsHAVTxt: string;
    lsAVGTxt: string;
    lsLAVTxt: string;
    lsBDLTxt: string;
    lsMDITxt: string;
    lsMOITxt: string;
    lsSVITxt: string;
    lsCSVTxt: string;
    lsBaselineTxt: string;
    lsSharedDataTxt: string;
    lsDownloadVisualOnly: string;
    lsTestTagTxt: string;
}

let strings: IViewTestsStrings;
export default strings = new LocalizedStrings({
    en: {       
        lsSettingsTxt: 'Settings',
        lsLogOutTxt: 'Logout',
        lsBackToProfileTxt: 'Back to Profile',
        lsTestHistory: 'Test History',
        lsReturnToActivityTxt: 'Return to Activity',
        lsDownloadTestTxt: 'Download Test',
        lsShareTestTxt: 'Share Test',
        lsShareReturnToActivityTxt: 'Share Return to Activity',
        lsDownloadTxt: 'Download',
        lsExportProfileTxt: 'Export Profile List',
        lsTestExportSuccessTxt: 'Tests exported successfully!',
        lsTestSharedSuccessTxt: 'Tests shared successfully!',
        lsTestSharedFailedTxt: 'Tests could not be shared.Please try again!',
        lsReturnToActivTestHisTxt: 'Return to Activity Test History',
        lsProfilesTxt: 'Profiles',
        lsTestTxt: 'Test',
        lsTestsTxt: 'Tests',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',        
        lsViewtxt: 'View',
        lsHomeTxt: 'Home',
        lsEditTxt: 'Edit',        
        lsOkTxt: 'Ok',    
        lsPrintTxt: 'Print',
        lsShareTxt: 'Share',
        lsDisclaimerTxt: 'Medical Disclaimer',
        lsDisclaimerInfoTxt: 'The FDA has not reviewed or evaluated any statements or information provided '
        + 'in conjunction with EyeGuide. EyeGuide Focus is not a medical device. '
        + 'EyeGuide Focus is not intended to diagnose, treat, cure, or prevent any health condition, disease '
        + ', illness, concussion or traumatic brain injury. If you experience any discomfort while utilizing '
        + 'EyeGuide Focus, discontinue use of EyeGuide Focus and consult your physician immediately. '
        + 'EyeGuide Focus is not a substitute for and should never be used in lieu of medical treatment '
        + 'and evaluation by a licensed physician.',
        lsSeverlyImpairedTxt: 'Extremely Poor',
        lsModeratelyImpairedTxt: 'Very Poor',
        lsMildlyImpairedTxt: 'Poor',
        lsBorderlineTxt: 'Borderline',
        lsLowAverageTxt: 'Low Average',
        lsAverageTxt: 'Average',
        lsHighAverageTxt: 'High Average',
        lsSuperiorTxt: 'Superior',
        lsVerySuperiorTxt: 'Very Superior',
        lsVSPTxt: 'VSP',
        lsSUPTxt: 'SUP', 
        lsHAVTxt: 'HAV', 
        lsAVGTxt: 'AVG', 
        lsLAVTxt: 'LAV', 
        lsBDLTxt: 'BDL', 
        lsMDITxt: 'MDI', 
        lsMOITxt: 'MOI', 
        lsSVITxt: 'SVI',
        lsCSVTxt: 'CSV',
        lsBaselineTxt: 'Baseline',
        lsSharedDataTxt: 'Shared Data',
        lsDownloadVisualOnly: 'Visual Only',
        lsTestTagTxt: 'test type',
    },
    es: {
        lsSettingsTxt: 'Configuraciones',
        lsLogOutTxt: 'Cerrar sesión',
        lsBackToProfileTxt: 'Volver al perfil',
        lsTestHistory: 'Historial de prueba',
        lsReturnToActivityTxt: 'Volver a la actividad',
        lsDownloadTestTxt: 'Descargar prueba',
        lsShareTestTxt: 'Compartir prueba',
        lsShareReturnToActivityTxt: 'Compartir Volver a la actividad',
        lsDownloadTxt: 'Descargar',
        lsExportProfileTxt: 'Exportar lista de perfiles',
        lsTestExportSuccessTxt: 'Tests exported successfully!',
        lsTestSharedSuccessTxt: 'Tests shared successfully!',
        lsTestSharedFailedTxt: 'Tests could not be shared.Please try again!',
        lsReturnToActivTestHisTxt: 'Regresar al historial de prueba de la actividad',
        lsProfilesTxt: 'Perfiles',
        lsTestsTxt: 'Pruebas',
        lsYesTxt: 'Sí',
        lsNoTxt: 'No',        
        lsViewtxt: 'Ver',
        lsHomeTxt: 'Casa',
        lsEditTxt: 'Editar',        
        lsOkTxt: 'De acuerdo',    
        lsPrintTxt: 'Impresión',
        lsShareTxt: 'Compartir',
        lsDisclaimerTxt: 'Medical Disclaimer',
        lsDisclaimerInfoTxt: 'The FDA has not reviewed or evaluated any statements or information provided'
        + 'in conjunction with EyeGuide. EyeGuide Focus is not a medical device.'
        + 'EyeGuide Focus is not intended to diagnose, treat, cure, or prevent any health condition, disease'
        + ', illness, concussion or traumatic brain injury. If you experience any discomfort while utilizing'
        + 'EyeGuide Focus, discontinue use of EyeGuide Focus and consult your physician immediately.'
        + 'EyeGuide Focus is not a substitute for and should never be used in lieu of medical treatment'
        + 'and evaluation by a licensed physician.',
        lsSeverlyImpairedTxt: 'Gravemente impedido',
        lsModeratelyImpairedTxt: 'Moderadamente deteriorado',
        lsMildlyImpairedTxt: 'Levemente deteriorado',
        lsBorderlineTxt: 'Límite',
        lsLowAverageTxt: 'Promedio bajo',
        lsAverageTxt: 'Promedio',
        lsHighAverageTxt: 'Alto promedio',
        lsSuperiorTxt: 'Superior',
        lsVerySuperiorTxt: 'Muy superior',
        lsVSPTxt: 'VSP',
        lsSUPTxt: 'SUP', 
        lsHAVTxt: 'HAV', 
        lsAVGTxt: 'AVG', 
        lsLAVTxt: 'LAV', 
        lsBDLTxt: 'BDL', 
        lsMDITxt: 'MDI', 
        lsMOITxt: 'MOI', 
        lsSVITxt: 'SVI',
        lsCSVTxt: 'CSV',
        lsBaselineTxt: 'Baseline',
        lsSharedDataTxt: 'Shared Data',
        lsDownloadVisualOnly: 'Visual Only',
        lsTestTagTxt: 'Tipo de prueba',
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/test/string.test.view.tsx